import { useQuery } from "@tanstack/react-query";
import { fetchLibraryBooks } from "@jambushrushti/services/publicBooks";

export function useLibraryCatalog() {
  return useQuery({
    queryKey: ["books-public", "library-catalog"],
    queryFn: ({ signal }) => fetchLibraryBooks(signal),
  });
}
